export default "__VITE_ASSET__CPeyNR5x__"